import styles from './Header.module.css';
import {Link, useLocation} from 'react-router-dom';
import logo from '../assets/logo.png';

export default function Header(){
  const location = useLocation();
  console.log(location);
	return(
		<div className={styles.header}>
    {/* <h1>MinhaAju: Vegetação</h1> */}
		<a href="#home"><img src={logo} width="20%" alt='MinhaAju logo'/></a>
    <div className={styles.headerButtons}>
      <Link style={location.pathname === '/' ? {pointerEvents: 'none', color: '#70e000'}: {}} to='/'>Mapa</Link>
      <Link style={location.pathname === '/Sobre' ? {pointerEvents: 'none', color: '#70e000'}: {}} to='/Sobre'>Sobre</Link>
      {/* <Link style={location.pathname === '/Contato' ? {pointerEvents: 'none', color: '#70e000'}: {}} to='/Contato'>Contato</Link> */}
      <Link style={location.pathname === '/Fontes' ? {pointerEvents: 'none', color: '#70e000'}: {}} to='/Fontes'>Fontes</Link>
    </div>
  </div>
	)
}